import { Component, HostListener, inject, LOCALE_ID, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { SettingsState } from '@app/_state/settings.state';
import { Router, RouterModule } from '@angular/router';
import { LogoutAction } from '@app/_state/settings.actions';
import { TaskState } from '@app/_state/task.state';
import { Task } from '@app/_models/task';
import { CommonModule } from '@angular/common';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { Account } from '@app/_models/account';
import { AuthService } from '@app/_services/auth.service';
import { NavigationLocalize } from '@app/navigation/navigation.localize';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { FormsModule } from '@angular/forms';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzButtonModule } from 'ng-zorro-antd/button';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NzLayoutModule,
    NzFlexModule,
    NzMenuModule,
    NzIconModule,
    NzToolTipModule,
    NzRadioModule,
    NzGridModule,
    NzPopoverModule,
    NzAvatarModule,
    NzCardModule,
    NzButtonModule,
  ]
})
export class NavigationComponent implements OnInit {

  store: Store = inject(Store);
  router: Router = inject(Router);
  authService = inject(AuthService);
  activeLocale = inject(LOCALE_ID);

  tasks$: Observable<Task[]> = this.store.select(TaskState.assigned);
  isAuthenticated$: Observable<boolean> = this.store.select(SettingsState.isAuthenticated);
  isGask$: Observable<boolean> = this.store.select(SettingsState.isGask);
  isAdmin$: Observable<boolean> = this.store.select(SettingsState.isAdmin);
  isKds$: Observable<boolean> = this.store.select(SettingsState.isKds);
  isKhc$: Observable<boolean> = this.store.select(SettingsState.isKhc);
  isKhcAdmin$: Observable<boolean> = this.store.select(SettingsState.isKhcAdmin);
  isCertificationUnit$: Observable<boolean> = this.store.select(SettingsState.isCertificationUnit);
  isOrganizationHeader$: Observable<boolean> = this.store.select(SettingsState.isOrganizationHeader);
  isSupport$: Observable<boolean> = this.store.select(SettingsState.isSupport);
  isDemo$: Observable<boolean> = this.store.select(SettingsState.isDemo);

  account: Account | null = null;
  isDropdownMenuOpen: boolean = false;

  isScrolled = false;

  @HostListener('window:scroll', ['$event'])
  onScroll() {
    this.isScrolled = window.scrollY > 15;
  }

  ngOnInit() {
    this.isAuthenticated$.subscribe(isAuthenticated => {
      if (isAuthenticated) {
        this.loadAccount();
      }
    });
  }

  loadAccount() {
    this.authService.me().subscribe(data => {
      this.account = data;
      console.log(this.account.organization);
    });
  }

  logout() {
    this.store.dispatch(new LogoutAction()).subscribe({
      next: () => {
        this.router.navigateByUrl('/login');
      }
    });
  }

  getFullName(): string {
    if (!this.account) {
      return '';
    }

    const lastName = this.account.lastName
      ? this.account.lastName.charAt(0).toUpperCase() + this.account.lastName.slice(1).toLowerCase()
      : '';

    const firstName = this.account.firstName
      ? this.account.firstName.charAt(0).toUpperCase() + this.account.firstName.slice(1).toLowerCase()
      : '';

    const fatherName = this.account.fatherName
      ? this.account.fatherName.charAt(0).toUpperCase() + this.account.fatherName.slice(1).toLowerCase()
      : '';

    if (lastName) {
      if (firstName) {
        return fatherName
          ? `${lastName} ${firstName.charAt(0).toUpperCase()}.${fatherName.charAt(0).toUpperCase()}.`
          : `${lastName} ${firstName.charAt(0)}.`;
      }
      return lastName;
    }

    return `${firstName} ${fatherName}`.trim();
  }

  getInitials(): string {
    if (!this.account) {
      return '';
    }

    const lastName = this.account.lastName
      ? this.account.lastName.charAt(0).toUpperCase() + this.account.lastName.slice(1).toLowerCase()
      : '';

    const firstName = this.account.firstName
      ? this.account.firstName.charAt(0).toUpperCase() + this.account.firstName.slice(1).toLowerCase()
      : '';

    const fatherName = this.account.fatherName
      ? this.account.fatherName.charAt(0).toUpperCase() + this.account.fatherName.slice(1).toLowerCase()
      : '';

    if (lastName) {
      if (firstName) {
        return fatherName
          ? `${lastName.charAt(0)}.${firstName.charAt(0)}`
          : `${lastName.charAt(0)}.${firstName.charAt(0)}`;
      }
      return `${lastName.charAt(0)}.`;
    }

    return `${firstName.charAt(0)}.${fatherName.charAt(0)}.`.trim();
  }

  getCurrentRoute() {
    return this.router.url;
  }

  changeLocale() {
    localStorage.setItem('locale', this.activeLocale);
    window.location.href = `/${this.activeLocale}${this.getCurrentRoute()}`;
  }

  openDropdownMenu() {
    this.isDropdownMenuOpen = !this.isDropdownMenuOpen;
  }

  navigationLocalize = NavigationLocalize;
}
